import { createAction } from '@reduxjs/toolkit';
import * as React from 'react';

import { useDispatch } from '../context';

export const pageSwitched = createAction<string>('page/switched');

/**
 * Acquire function used to track page switch events
 *
 * Accepts type argument to allow narrowing down expected events
 *
 * @example
 * // Basic usage wtih React Router
 * const location = useLocation()
 * const pageSwitched = usePageSwitched()
 *
 * useEffect(() => {
 *   pageSwitched()
 * }, [location.pathname, pageSwitched])
 */
export function usePageSwitched() {
  const dispatch = useDispatch();
  return React.useCallback(
    (pathname: string) => {
      dispatch(pageSwitched(pathname));
    },
    [dispatch],
  );
}
